import { PermissionEntity, useCheckPermissions } from '../permissions'

export const useCheckBulkPermissions = (type: PermissionEntity) => {
  const [canBulkDelete, canDelete, canBulkUpdate, canUpdate] =
    useCheckPermissions(
      `${type}_bulk_delete`,
      `${type}_delete`,
      `${type}_bulk_update`,
      `${type}_update`,
    )

  const hasUpdatePermission = canBulkUpdate && canUpdate

  const hasDeletePermission = canBulkDelete && canDelete

  return { hasUpdatePermission, hasDeletePermission }
}
